
import {
  computed,
  defineComponent,
  h,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import {
  AdminTableLayout,
  ReportTable,
  OrderTravel,
} from "@/components/Common";

import { fmtExtractWaybillCode, zcatPoint, zcatView } from "@/utils/utilFuns";

import { useRoute, useRouter } from "vue-router";
import {
  useDynamicDialog,
  usePagination,
  useReportTableShowColumn,
} from "@/hooks";

import { tableColumn2 as tableColumn } from "./billDetailTableColum";

import {
  FileUploadUnity,
  GetTractRecord,
  QueryAccountBillAdditionalDetailList,
  QueryIntertemporalReconciliationList,
} from "@/api-server/modules/defaultServer";
import { formatThisMonth } from "@/utils/formatter";
import { useStore } from "vuex";
import { RootState } from "@/@types/store";
import { ElLink, ElMessage, ElNotification } from "element-plus";

import downloadCenter from "@/components/Admin/download-center/download-center.vue";

const initFormData = {
  contractProjectId: "",
  borrowingDate: "",
  accountCycle: -1,
  customerId: -1,
  siteId: -1,
};

export default defineComponent({
  name: "BillDetail2",
  components: {
    AdminTableLayout,
    ReportTable,
    OrderTravel,
    downloadCenter,
  },

  props: {
    initForm: {
      type: Object,
      default: () => ({ ...initFormData }),
    },
  },

  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore<RootState>();
    const { getModelUUID, openModel } = useDynamicDialog();
    const formData = reactive({
      ...(props.initForm as any),
    });

    const dialog = reactive<{
      visible: boolean;
      loading: boolean;
      orderInfo: BUSINESS_SERVE_PLATFORM_PC.GetTractRecordResponseDataItem;
    }>({
      visible: false,
      loading: false,
      orderInfo: {},
    });

    const calendarTime = ref<Date[]>([]);

    const { showTableColumn } = useReportTableShowColumn(tableColumn);
    const {
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      tableData,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      errorCode,
    } = usePagination(
      QueryIntertemporalReconciliationList.fetch,
      formData,
      (editFormData) => {
        zcatPoint(["跨期结算", "查询"]);
        if (editFormData.billCode) {
          return {
            contractProjectId: editFormData.contractProjectId,
            borrowingDate: editFormData.borrowingDate,
            accountCycle: editFormData.accountCycle,
            customerId: editFormData.customerId,
            siteId: editFormData.siteId,
            billCodes: fmtExtractWaybillCode(editFormData.billCode, 1000),
          };
        }
        return {
          contractProjectId: editFormData.contractProjectId,
          borrowingDate: editFormData.borrowingDate,
          accountCycle: editFormData.accountCycle,
          customerId: editFormData.customerId,
          siteId: editFormData.siteId,
        };
      }
    );

    const handleClick = async (billCodes: string) => {
      dialog.visible = true;
      dialog.loading = true;
      const {
        data: { data: billDataList },
      } = await GetTractRecord.fetch({
        billCodes: [billCodes],
      });
      dialog.loading = false;
      billDataList &&
        billDataList.length > 0 &&
        (dialog.orderInfo = billDataList[0]);
    };

    const downloadLoading = ref(false);
    const handleExportAll = async () => {
      zcatPoint(["跨期结算", "导出"]);
      downloadLoading.value = true;
      const inputJson = ref({});
      if (formData.billCode) {
        inputJson.value = {
          contractProjectId: formData.contractProjectId,
          borrowingDate: formData.borrowingDate,
          accountCycle: formData.accountCycle,
          customerId: formData.customerId,
          siteId: formData.siteId,
          billCodes: fmtExtractWaybillCode(formData.billCode, 1000),
        };
      } else {
        inputJson.value = {
          contractProjectId: formData.contractProjectId,
          borrowingDate: formData.borrowingDate,
          accountCycle: formData.accountCycle,
          customerId: formData.customerId,
          siteId: formData.siteId,
        };
      }
      await FileUploadUnity.fetch({
        executeType: "intertemporalReconciliationList",
        inputJson: JSON.stringify(inputJson.value),
      });

      downloadLoading.value = false;
      const notify = ElNotification({
        title: "导出成功",
        message: '点击<span class="color-blue">查看</span>下载中心',
        dangerouslyUseHTMLString: true,
        type: "success",
        customClass: "pointer",
        duration: 10000,
        async onClick() {
          notify.close();
          const uuid = await getModelUUID(
            "admin/download-center/downloadDialog"
          );
          openModel(uuid, {
            formData: {},
          });
        },
      });
    };

    function deleteRepeatOrderNumber() {
      formData.billCode = Array.from(
        new Set(formData.billCode.split("\n"))
      ).join("\n");
    }

    async function handleReAccount(row: any) {
      zcatPoint(["跨期结算", "我要调账"]);
      const uuid = await getModelUUID(
        "admin/bill-manager/bill-list/reAccountDialog1"
      );
      openModel(
        uuid,
        {
          formData: { ...row, fee: row.crossFee },
          dealType: 3,
        },
        {
          updateSuccess: () => {
            requestTableData();
            const notify = ElNotification({
              title: "发起调账成功",
              message: '点击前往调账明细<span class="color-blue">查看</span>',
              dangerouslyUseHTMLString: true,
              type: "success",
              customClass: "pointer",
              duration: 10000,
              async onClick() {
                notify.close();
                router.push({
                  path: "/admin/bill-manager/adjust-detail",
                  query: {
                    contractProjectId: formData.contractProjectId,
                    borrowingDate: formData.borrowingDate,
                    accountCycle: formData.accountCycle,
                    customerId: formData.customerId,
                    siteId: formData.siteId,
                  },
                });
              },
            });
          },
        }
      );
    }

    const billCodeHandle = ({ row }: any) => {
      return h(
        ElLink as any,
        {
          type: "primary",
          style: "margin-right: 5px",
          onClick: () => handleClick(row.billCode),
        },
        row.billCode
      );
    };

    onMounted(() => {
      zcatView(["页面", "跨期结算"]);
    });
    const actionsCodeHandle = ({ row }: any) => {
      return (
        formData.status != 1 &&
        h(
          ElLink as any,
          {
            type: "primary",
            onClick: () => handleReAccount(row),
          },
          "我要调账"
        )
      );
    };
    return {
      formData,
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      showTableColumn,
      tableData,
      handleClick,
      dialog,
      formatThisMonth,
      calendarTime,
      errorCode,
      deleteRepeatOrderNumber,
      store,
      downloadLoading,
      handleExportAll,
      handleReAccount,
      billCodeHandle,
      actionsCodeHandle,
    };
  },
});
